import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

const Unauthorized = () => {
  return (
    <div className="unauth-container">
      <div className="unauth-card">
        <FaExclamationTriangle className="unauth-icon" />
        <h1 className="unauth-title">Unauthorized Access</h1>
        <p className="unauth-subtitle">
          Oops! You don’t have permission to view this page.
        </p>
        <a href="/login" className="unauth-button">
          Go to Login
        </a>

        {/* Keyframe animations */}
        <style>{`
          /* Page fade-in */
          .unauth-container {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            background: linear-gradient(135deg, #ff416c, #ff4b2b);
            font-family: 'Roboto', sans-serif;
            animation: fadeIn 1s ease-in-out;
          }

          /* Card pop-in */
          .unauth-card {
            background: #fff;
            padding: 50px 40px;
            border-radius: 25px;
            box-shadow: 0 20px 50px rgba(0,0,0,0.25);
            text-align: center;
            max-width: 420px;
            animation: popIn 0.8s ease-out;
            position: relative;
            overflow: hidden;
          }

          /* Icon floating + color pulse */
          .unauth-icon {
            font-size: 70px;
            color: #ff416c;
            margin-bottom: 20px;
            animation: float 2s ease-in-out infinite, pulse 1.5s infinite;
          }

          /* Title gradient */
          .unauth-title {
            font-size: 32px;
            font-weight: 800;
            margin-bottom: 15px;
            background: linear-gradient(45deg, #ff416c, #ff4b2b);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .unauth-subtitle {
            font-size: 17px;
            color: #666;
            margin-bottom: 30px;
          }

          /* Button hover effect */
          .unauth-button {
            display: inline-block;
            text-decoration: none;
            background: linear-gradient(45deg, #ff416c, #ff4b2b);
            color: #fff;
            padding: 14px 30px;
            border-radius: 50px;
            font-weight: 600;
            font-size: 16px;
            transition: transform 0.3s, box-shadow 0.3s;
          }

          .unauth-button:hover {
            transform: scale(1.1);
            box-shadow: 0 10px 25px rgba(255,65,108,0.5);
          }

          /* Animations */
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }

          @keyframes popIn {
            from { transform: scale(0.7); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }

          @keyframes float {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-15px); }
          }

          @keyframes pulse {
            0%, 100% { color: #ff416c; }
            50% { color: #ff9a76; }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Unauthorized;
